import React from 'react';
import TextInput from '../../form/TextInput';
import createForm from "./Form";
import TypeTextEditor from "../../form/TypeTextEditor";
import UrlField from "../../form/UrlField";

class staticcontentForm extends React.Component {

    render() {
        return (
            <form onSubmit={ this.props.handleSubmit }>
                <div className="row form-row">
                    <div className="col-md-2">
                        <TextInput name={this.props.componentConfig.idfield} value={ this.props.values[this.props.componentConfig.idfield] } label="Kód" role="idfield"/>
                    </div>
                    <div className="col-md-10">
                        <TextInput name="name" value={this.props.values.name} label="Megnevezés" saveChanges={this.props.setFieldValue} {...this.props.getFieldProps("name")}/>
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-12">
                        <TypeTextEditor name="content" label="Tartalom" data={this.props.values} componentConfig={this.props.componentConfig} getFieldProps={this.props.getFieldProps} setFieldValue={this.props.setFieldValue}/>
                    </div>
                </div>
                {this.props.componentConfig.fielddefs.url &&
                <UrlField {...this.props}/>}
            </form>
        );
    }
}

export default createForm(staticcontentForm);
